import React, { useState } from 'react';
import { useHistory, useLocation, Link } from "react-router-dom";
import { Layout, Menu, Image, Space, Button, Row, Col, Grid, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Logo from '../../../assets/img/WCHSS.png';
const { useBreakpoint } = Grid;
const { Header } = Layout;

function Headers() {
  const [visible, setVisible] = useState(false);
  
  let history = useHistory()
  let location = useLocation()
  let { xs, xxl } = useBreakpoint()
  
  const handleMenu = (e) => {
    if(e.keyPath[1] === "/wchss-2022" && e.keyPath[0] === "/go"){
      window.open('http://wchss-2022.binawan.ac.id', '_blank');
      setVisible(false)
    }else if(e.keyPath[1] === "/wchss-2022" && e.keyPath[0] === "/publication"){
      window.open('https://www.atlantis-press.com/proceedings/wchss-22/articles', '_blank');
      setVisible(false)
    }else{
      history.push(e.key)
      setVisible(false)
    }
    
    // wchss-2022.binawan.ac.id
  }

  const showDrawer = () => {
    setVisible(true)
  };

  const onClose = () => {
    setVisible(false)
  };
  
  const items = [
    { label: 'Home', key: '/' },
    { label: 'About', key: '/about' },
    { label: 'Call For Papers', key: '/call-for-papers' },
    { label: 'Sponsorship', key: '/sponsorship' },
    { label: 'Publications', key: '/publications' },
    { label: 'Contact Us', key: '/contact-us' },
    {
      label: 'Archive',
      key: '/archive',
      children: [
        { 
          label: 'WCHSS 2022', 
          key: '/wchss-2022', 
          children: [
            { label: 'Go to WCHSS 2022', key: '/go' },
            { label: 'Publication', key: '/publication' },
            { label: 'Gallery', key: '/gallery' },
          ]
        }
      ],
    },
  ]
  
  return (
    <Header className='header' style={{ height: 80, boxShadow: location.pathname === '/' ? null : '1px 4px 4px 1px #f2f2f2' }}>
      <Row justify="space-around" align="middle" style={{ padding: xxl ? '0 230px' : 0, margin: 0 }}>
        <Col xxl={2} lg={4} xs={8}>
          <Image
            width={'100%'}
            src={ Logo }
            preview={false}
          />
        </Col>
        <Col xxl={20} lg={20} xs={16}>
          {
            xs ?
              <Space style={{ float: 'right' }}>
                <Link to='/registration'>
                  <Button className='button-registration'>Registration</Button>
                </Link>
                <Button size='large' icon={<MenuOutlined />} onClick={showDrawer} style={{ borderRadius: 4 }} />
              </Space>
            :
              <Space style={{ float: 'right' }}>
                <Menu
                  mode="horizontal"
                  defaultSelectedKeys={['/']}
                  selectedKeys={location.pathname}
                  onClick={handleMenu}
                  items={items}
                  style={{ height: 80, paddingTop: 8 }}
                />
                <Link to='/registration'>
                  <Button className='button-registration'>Registration</Button>
                </Link>
              </Space>

          }
        </Col>
      </Row>
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={'50%'}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="vertical"
          defaultSelectedKeys={['/']}
          selectedKeys={location.pathname}
          onClick={handleMenu}
          items={items}
        />
      </Drawer>
    </Header>
  )
}

export default Headers